'use strict';

/**
 * Created by user on 27.03.2017.
 */
(function ($) {
    $.Cart = {
        data: { items: [] },
        timeout: {},
        init: function init(settings) {
            var defaults = {
                content: '.content', // селектор главного блока на странице корзины
                count: '.prod span font', // в блоке .prod на странице количество товаров в корзине
                summ: '.summ span font', // в блоке .prod общая сумма
                add: '.tocart', // селектор элемента, при нажатии на который товар будет добавлен в корзину
                addattr: 'catalogproduct-id', // атрибут элемента, содержащий ID
                counta_event: 'numbers-row',
                counta: '.carts .actions .count input', // поле содержащее количество товаров одного наименования в корзине
                countattr: 'catalogproduct-id', // атрибут поля, содержащий ID товара
                countvattr: 'value', // атрибут поля, содержащий количество товаров
                del: '.carts .actions .delete input', // селектор элемента, при нажатии на который 1 наименование товара будет удалено из корзины
                delattr: 'catalogproduct-id', // атрибут элемента, содержащий ID товара
                delrowattr: 'data-item-row',
                clear: '.cartclear', // селектор элемента, при нажатии на который корзина будет очищена
                topcart: '.topcart', // селектор ссылки ведущей в корзину
                cart_popup: '.basket-hover', // селектор ссылки ведущей в корзину
                urladd: '/cart/add/', // url добавления товара в корзину
                urlget: '/cart/get/', // url информации о количестве товаров в корзине и общей сумме
                urlcart: '/cart/', // url непосредственно самой корзины
                urlcount: '/cart/count/', // url обновления количества товаров одного наименования
                urlclear: '/cart/clear/', // url полной очистки корзины
                urldel: '/cart/del/', // url удаления одного наименования товара из корзины
                urlpopup: '/cart/preview', // url удаления одного наименования товара из корзины
                type_message: 'flash', // тип сообщения при добавлении товара в корзину
                time_message: 3000, // время показа сообщения
                interval: 10000 // интервал времени, через который будет обновляться блок с информацией о количестве товаров в корзине и общей сумме
            };
            $.extend(defaults, settings);
            this.settings = defaults;
            return this;
            // инициализация модуля
        },

        sendRequest: function sendRequest(action, data, is_init) {

            data = data || {};
            return $.ajax($.extend({
                url: action,
                type: action === this.settings.urlget ? 'get' : 'post',
                data: data,
                dataType: 'json',
                success: function success(response_data) {
                    if (response_data.success) {
                        if (response_data.cart&&(JSON.stringify(this.data) !== JSON.stringify(response_data.cart))) {
                            this.data = response_data.cart;
                            is_init || $(document).trigger("modified.cart", [response_data]);
                            $(document).trigger("updTpl.cart", [response_data]);
                        }
                    } else if (response_data.errors) {
                        console.log(response_data.errors.join("\n"));
                        $(document).trigger("errors.cart", response_data.errors);
                    } else {
                        console.error('Wrong request!');
                    }
                },
                error: function error(xhr, ajaxOptions, thrownError) {
                    console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                }
            }, data instanceof FormData ? { contentType: false, processData: false } : {}));
        },
        add: function add(data) {
            return this.sendRequest(this.settings.urladd, data).done(function (response_data) {
                $(document).trigger("add.cart", [response_data]);
                window.dataLayer = window.dataLayer || [];
                // dataLayer.push({'event': 'DobavlenievKorzinu'});
            });
        },


        quick: function quick(data) {
            return this.sendRequest(this.settings.urlquick, data).done(function (response_data) {
                $(document).trigger("quick.cart", [response_data]);
            });
        },
        get: function get() {

            return this.sendRequest(this.settings.urlget, null, true).done(function (response_data) {
                $(document).trigger("get.cart", [response_data]);
            });
        },

        count: function count(data) {
            return this.sendRequest(this.settings.urlcount, data).done(function (response_data) {
                $(document).trigger("count.cart", [response_data]);
            });
        },

        del: function del(data) {

            return this.sendRequest(this.settings.urldel, data).done(function (response_data) {
                $(document).trigger("del.cart", [response_data]);
            });
        },
        clear: function clear() {
            $.post($.Cart.settings.urlclear, {}, function (data) {
                $($.Cart.settings.content).html(data); // обычно в data приходит информация о том, что корзина пуста
                $.Cart.get(); // здесь будет всё по нулям, а ссылка на корзину станет неактивной
            });
        },
        showMessage: function showMessage(message) {
            if (message === undefined) {
                return;
            } // передается текст сообщения
            if ($.Cart.settings.type_message === 'alert') {
                // если alert
                alert(message); // комментарии излишни
            } else if ($.Cart.settings.type_message === 'flash') {
                // если flash
                if ($('.flashmessage').length === 0) // если элементов с сообщением в документе не найдено, то
                    $('<div/>').addClass('flashmessage').html(message).hide().appendTo('body').fadeIn(); // создаем его, добавляем в него сообщение, вставляем его перед закрывающим тегом </body>, и плавно отображаем
                else // если найдено
                    $('.flashmessage').html(message); // то вставляем в него сообщение
                if (typeof $.Cart.message_time === 'number') // если уже происходит отсчет времени до завершения показа сообщения
                    clearTimeout($.Cart.message_time); // сбрасываем его
                $.Cart.message_time = setTimeout(function () {
                    // заводим новый таймер
                    $('.flashmessage').fadeOut(function () {
                        // по истечению времени показа плавно скрываем
                        $(this).remove(); // при завершении скрытия удаляем элемент
                    });
                }, $.Cart.settings.time_message); // время показа сообщения
            } else if ($.Cart.settings.type_message === 'modal') {
                $($.Cart.settings.addmodal + ' ' + $.Cart.settings.addmodal_content).html(message);
                $($.Cart.settings.addmodal).modal();
            } else if ($.Cart.settings.type_message === 'toastr') {
                toastr.options = {
                    "closeButton": false,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": true,
                    "positionClass": "toast-top-center",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "10000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                };
                if (message.success === true) {
                    toastr.success(message.message);
                } else {
                    toastr.error(message.message);
                }
            }
        }
    };
})(jQuery);
